import './Services.css';
import ImageCardGrid from './ImageCardGrid';

function Services() {
    return (
        <div className="App-s">
            <section className="content2 service-hero" aria-labelledby="services-heading">
                <div className="right-content2 service-hero-copy">
                    <h1 id="services-heading" className="topic2">
                        <span className="blue-text">Our services </span>
                        and Expertise
                    </h1>

                    <p>
                        We craft innovative, reliable, and scalable software solutions tailored to your unique business needs.
                        Our team blends cutting-edge technology with deep industry expertise to deliver results that drive growth.
                    </p>
                </div>

                <div className="right-content2 service-hero-visual" aria-hidden="true">
                    <img
                        className="leftImage1"
                        alt=""
                        src="/images/img-service2.png"
                    />
                    <img
                        className="octagon-shape-clip-5"
                        alt=""
                        src="/images/octogon.png"
                    />
                </div>
            </section>

            <section className="image-card-grid-container" aria-label="Our software services">
                <ImageCardGrid />
            </section>

            <section className="content3-s" aria-labelledby="solutions-heading">
                <div className="left-content3 service-solutions-visual" aria-hidden="true">
                    <img
                        className="octagon-shape-clip-6"
                        alt=""
                        src="/images/octogon.png"
                    />
                    <img
                        className="overlapimage"
                        alt=""
                        src="/images/img-service11.png"
                    />
                </div>

                <div className="right-content3 service-solutions-copy">
                    <h2 id="solutions-heading" className="head-product">
                        <span className="blue-text">Innovative </span>
                        Solutions
                    </h2>

                    <p className="content-paragraph1">
                        We are not just customer-centric. We are customer-obsessed. Our obsession is understanding your unique
                        needs and aspirations, then weaving software magic that not only meets them but propels you into the future.
                    </p>
                </div>
            </section>
        </div>
    );
}

export default Services;
